import React from 'react';
import {Trans} from '@lingui/react';

import {ISummaryHttpMonitors} from 'features/http';

import Availability from './Availability/Availability';
import MonitorInfo from './MonitorInfo/MonitorInfo';

import styles from './BlockInfo.module.scss';


interface BlockInfoProps {
    summary: ISummaryHttpMonitors,
}

const BlockInfo: React.FC<BlockInfoProps> = ({summary}) => {

    return (
        <div className={styles.info_wrapper}>
            <div className={styles.availability_wrapper}>
                <div className={styles.title}>
                    <Trans id="home.info.title" message="Доступность" />
                </div>
                <Availability
                    periodDay={summary.availability1}
                    periodWeek={summary.availability7}
                    periodMount={summary.availability30}
                />
            </div>
            <MonitorInfo classname={styles.paused_desc} counter={summary.paused} isLink={summary.paused > 0}/>
        </div>
    );
};

export default BlockInfo;
